import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import {Language, styleguideEN,styleguideCY } from 'cw-styleguide-react';
import localEN from "./translations/en/local";
import localCY from "./translations/cy/local";

i18n
  .use(initReactI18next)
  .init({
    lng: Language.currentLanguage,
    preload: ['en', 'cy'],
    fallbackLng: false,
    debug: false,
    ns: ['styleguide'],
    defaultNS: 'styleguide',
    interpolation: {
      escapeValue: false,
    },
  });
i18n.addResourceBundle('en', 'styleguide', styleguideEN);
i18n.addResourceBundle('cy', 'styleguide', styleguideCY);
i18n.addResourceBundle('en', 'local', localEN);
i18n.addResourceBundle('cy', 'local', localCY);
export default i18n;
